__turbopack_context__.v({
  "caret": "website-rotating-headline-module__D_7nJW__caret",
  "heightReserve": "website-rotating-headline-module__D_7nJW__heightReserve",
  "layout": "website-rotating-headline-module__D_7nJW__layout",
  "typed": "website-rotating-headline-module__D_7nJW__typed",
  "visible": "website-rotating-headline-module__D_7nJW__visible",
  "word": "website-rotating-headline-module__D_7nJW__word",
});
